// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"857c575e","545":"319ec8e7","787":"43458f8d"}[chunkId] + ".chunk.js";
};